import { render, staticRenderFns } from "./DocumentChildListModal.vue?vue&type=template&id=2f9e1c18"
import script from "./DocumentChildListModal.vue?vue&type=script&lang=js"
export * from "./DocumentChildListModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports